import {gql} from '@apollo/client';

export const logMutations = {
    CREATE_LOG: gql`
        mutation CreateLog($type: LOGS_CONFIG_ENUM!, $input: LogDetailInput!) {
            createLog(type: $type, input: $input)
        }
    `,
};
